"use strict";

var userSettingsWidget = function () {
  var snListTemplate = '';
  var mask = null;
  var userSettingsWidgetParams = {
    model: {},
    url: {},
    template: {
      passTemplate: "<p>\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C?</p>",
      socialsTemplate: "<p>\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u0435\u0442\u044C \u043E\u0442 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438?</p>"
    }
  };

  function unbindHandlers() {
    // $(document).off('click', '#changePassBtn');
    $(document).off('click', '#changeLoginBtn');
    $(document).off('click', '#changePhoneNumberBtn');
    $(document).off('click', '.person-socials-remove');
    $(document).off('click', '.link -no-border social-link-item');
  }

  function initMask() {
    $(".input-phone").each(function (i, input) {
      window.intlTelInput(input, {
        autoPlaceholder: "off",
        initialCountry: "ru",
        preferredCountries: ['ru'],
        separateDialCode: true
      });
      var iti = window.intlTelInputGlobals.getInstance(input);
      var maskOptions = null;
      var cData = iti.getSelectedCountryData();

      if (cData.iso2 === "ru") {
        maskOptions = {
          mask: '000 0000000'
        };
      } else {
        maskOptions = {
          mask: '0000000000[00]'
        };
      }

      mask = new IMask(input, maskOptions);
      $(document).on("countrychange", input, function () {
        var iti = window.intlTelInputGlobals.getInstance(input);
        var cData = iti.getSelectedCountryData();

        if (cData.iso2 === "ru") {
          maskOptions = {
            mask: '000 0000000'
          };
        } else {
          maskOptions = {
            mask: '0000000000[00]'
          };
        }

        mask.updateOptions(maskOptions);
        mask.value = "";
      });
    });
  }

  function reInitMask(input) {
    var iti = window.intlTelInputGlobals.getInstance(input[0]);
    var maskOptions = null;
    var cData = iti.getSelectedCountryData();

    if (cData.iso2 === "ru") {
      maskOptions = {
        mask: '000 0000000'
      };
    } else {
      maskOptions = {
        mask: '0000000000[00]'
      };
    }

    mask.updateOptions(maskOptions);
  }

  function resetPassword() {
    modalDialog.busyIndicator(true);
    $.ajax({
      type: 'POST',
      url: userSettingsWidgetParams.url.changePwg,
      data: {
        mail: userSettingsWidgetParams.model.EMail
      },
      success: function success(xhr) {
        modalDialog.busyIndicator(false);

        if (xhr.result === 'ok') {
          modalDialog.showBaseWnd({
            title: 'Внимание',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return xhr.message;
            }
          });
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return xhr.message;
            }
          });
        }
      }
    });
  }

  function delSnMapping(sn) {
    $.ajax({
      type: 'POST',
      url: userSettingsWidgetParams.url.delSnAuth,
      data: {
        socialNetwork: sn
      },
      success: function success(data) {
        if (data.Success) {
          // обновляем темплейт с социальными сетями
          $(".social-link-".concat(data.Result)).parent().removeClass('-binded');
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return data.Result;
            }
          });
        }
      }
    });
  }

  function getSnMapping() {
    $.ajax({
      type: 'GET',
      url: userSettingsWidgetParams.url.getSnMapping,
      success: function success(data) {
        if (data.Success) {
          $('.user-list-body').remove();
          $('.user-list-content').html(snListTemplate.render({
            LoginProviders: data.Result
          }));
        } else {
          modalDialog.showBaseWnd({
            title: 'Ошибка',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return data.message;
            }
          });
        }
      }
    });
  }

  function compileTemplate() {
    snListTemplate = Hogan.compile(userSettingsWidgetParams.template.snList);
  }

  function bindHandlers() {
    //$(document).on('click', '#changePassBtn', function () {
    //    const $credentailsModal = $('#personCredentialsModal');
    //    $credentailsModal.html(userSettingsWidgetParams.template.passTemplate);
    //    $credentailsModal.showAsModal({
    //        title: 'Внимание',
    //        buttons: [
    //            {
    //                title: 'Да',
    //                big: true,
    //                primary: true,
    //                onClick: () => {
    //                    resetPassword();
    //                },
    //            },
    //            {
    //                title: 'Нет',
    //                big: true,
    //            },
    //        ],
    //    });
    //});
    $(document).on('click', '#changeLoginBtn', function () {
      modalDialog.busyIndicator(true);
      modalCodeCountdown.timerOn = false;
      $('#check-confirmation-code').hide();
      $('#resend-check-param').show();
      $.ajax({
        type: 'POST',
        url: userSettingsWidgetParams.url.changeLogin,
        data: {
          mail: userSettingsWidgetParams.model.EMail
        },
        success: function success(xhr) {
          var $credentailsModal = $('#personCredentialsModal');
          $credentailsModal.html(xhr);
          modalDialog.busyIndicator(false);
          $credentailsModal.showAsModal({
            title: 'Смена адреса электронной почты',
            buttons: [{
              title: 'Проверить',
              big: true,
              primary: true,
              onClick: function onClick() {
                var isValid = true;
                var validations = ['validateValuesLength', 'validateRequiredValues', 'validatePattern'];
                var userId = changeLogin.getData().model.userId;
                var doChangeLoginPath = changeLogin.getData().url.doChangeLogin;
                var dataSet = {
                  login: $('#NewLogin').val().trim()
                };
                validations.forEach(function (check) {
                  var passedValidation = validation[check](dataSet);
                  isValid = isValid && passedValidation;
                });

                if (isValid) {
                  chekLogin('#main-phone-number-modal', dataSet.login, "Email").then(function (data) {
                    if (data) {
                      modalDialog.busyIndicator(true);
                      $.ajax({
                        type: 'POST',
                        url: doChangeLoginPath,
                        data: {
                          UserId: userId,
                          NewLogin: dataSet.login
                        },
                        success: function success(xhr) {
                          if (xhr.Success) {
                            modalDialog.showBaseWnd({
                              title: 'Адрес электронной почты успешно изменен',
                              buttons: [{
                                title: 'Хорошо',
                                big: true,
                                primary: true
                              }],
                              onDrawContent: function onDrawContent() {
                                return xhr.Result;
                              }
                            });
                            $('#profile-email-field-wrapper input').val(dataSet.login);
                            userSettingsWidgetParams.model.EMail = dataSet.login;
                            modalDialog.busyIndicator(false);
                          } else {
                            modalDialog.showBaseWnd({
                              title: 'Не удалось изменить адрес электронной почты',
                              buttons: [{
                                title: 'Хорошо',
                                big: true,
                                primary: true
                              }],
                              onDrawContent: function onDrawContent() {
                                return xhr.Result;
                              }
                            });
                            modalDialog.busyIndicator(false);
                          }
                        },
                        error: function error(xhr) {
                          modalDialog.showBaseWnd({
                            title: 'Не удалось изменить адрес электронной почты',
                            buttons: [{
                              title: 'Хорошо',
                              big: true,
                              primary: true
                            }],
                            onDrawContent: function onDrawContent() {
                              return xhr.Result;
                            }
                          });
                          modalDialog.busyIndicator(false);
                        }
                      });
                    } else {
                      modalDialog.showBaseWnd({
                        title: 'Не удалось изменить адрес электронной почты',
                        buttons: [{
                          title: 'Хорошо',
                          big: true,
                          primary: true
                        }],
                        onDrawContent: function onDrawContent() {
                          return xhr.Result;
                        }
                      });
                    }
                  }); // modalDialog.busyIndicator(true);
                  // $.ajax({
                  //     type: 'POST',
                  //     url: loginData.url.doChangeLogin,
                  //     data: {
                  //         userId: loginData.model.userId,
                  //         NewLogin: dataSet.login,
                  //     },
                  //     success: data => {
                  //         if (data.Success) {
                  //             location.href = data.Result;
                  //         } else {
                  //             modalDialog.busyIndicator(false);
                  //             modalDialog.showBaseWnd({
                  //                 title: 'Ошибка',
                  //                 buttons: [{
                  //                     title: 'Хорошо',
                  //                     big: true,
                  //                     primary: true,
                  //                 }],
                  //                 onDrawContent: () => data.Result,
                  //             });
                  //         }
                  //     },
                  // });
                }

                return isValid;
              }
            }, {
              title: 'Отмена',
              big: true
            }]
          });
        }
      });
    });
    $(document).on('click', '#changePhoneNumberBtn', function () {
      modalCodeCountdown.timerOn = false;
      $('#check-confirmation-code').hide();
      $('#resend-check-param').show();
      modalDialog.busyIndicator(true);
      $.ajax({
        type: 'POST',
        url: userSettingsWidgetParams.url.changePhone,
        data: {
          phone: userSettingsWidgetParams.model.Phone
        },
        success: function success(xhr) {
          var $credentailsModal = $('#personCredentialsModal');
          $credentailsModal.html(xhr);
          modalDialog.busyIndicator(false);
          $credentailsModal.showAsModal({
            title: 'Смена номера мобильного телефона',
            "class": " _scroll-none",
            buttons: [{
              title: 'Проверка номера',
              big: true,
              primary: true,
              onClick: function onClick() {
                var isValid = true;
                var validations = ['validateValuesLength', 'validateRequiredValues', 'validatePattern'];
                var userId = changePhone.getData().model.userId;
                var doChangePhonePath = changePhone.getData().url.doChangePhone;
                var iti = window.intlTelInputGlobals.getInstance($('#NewPhone')[0]);
                var dataSet = {
                  phone: iti.getNumber(intlTelInputUtils.numberFormat.E164)
                };
                validations.forEach(function (check) {
                  var passedValidation = validation[check](dataSet);
                  isValid = isValid && passedValidation;
                });

                if (isValid) {
                  chekLogin('#main-phone-number-modal', dataSet.phone, "Phone").then(function (data) {
                    if (data) {
                      modalDialog.busyIndicator(true);
                      $.ajax({
                        type: 'POST',
                        url: doChangePhonePath,
                        data: {
                          UserId: userId,
                          NewPhone: dataSet.phone
                        },
                        success: function success(xhr) {
                          if (xhr.Success) {
                            modalDialog.showBaseWnd({
                              title: 'Номер телефона успешно изменен',
                              buttons: [{
                                title: 'Хорошо',
                                big: true,
                                primary: true
                              }],
                              onDrawContent: function onDrawContent() {
                                return xhr.Result;
                              }
                            });
                            $('#profile-phone-field-wrapper input').val(dataSet.phone);
                            userSettingsWidgetParams.model.Phone = dataSet.phone;
                            reInitMask($('#NewPhone'));
                            modalDialog.busyIndicator(false);
                          } else {
                            modalDialog.showBaseWnd({
                              title: 'Не удалось изменить номер телефона',
                              buttons: [{
                                title: 'Хорошо',
                                big: true,
                                primary: true
                              }],
                              onDrawContent: function onDrawContent() {
                                return xhr.Result;
                              }
                            });
                            modalDialog.busyIndicator(false);
                          }
                        },
                        error: function error(xhr) {
                          modalDialog.showBaseWnd({
                            title: 'Не удалось изменить номер телефона',
                            buttons: [{
                              title: 'Хорошо',
                              big: true,
                              primary: true
                            }],
                            onDrawContent: function onDrawContent() {
                              return xhr.Result;
                            }
                          });
                          modalDialog.busyIndicator(false);
                        }
                      });
                    } else {
                      modalDialog.showBaseWnd({
                        title: 'Не удалось изменить номер телефона',
                        buttons: [{
                          title: 'Хорошо',
                          big: true,
                          primary: true
                        }],
                        onDrawContent: function onDrawContent() {
                          return xhr.Result;
                        }
                      });
                    }
                  }); // modalDialog.busyIndicator(true);
                  // $.ajax({
                  //     type: 'POST',
                  //     url: phoneData.url.doChangePhone,
                  //     data: {
                  //         userId: phoneData.model.userId,
                  //         NewPhone: dataSet.phone,
                  //     },
                  //     success: data => {
                  //         if (data.Success) {
                  //             location.href = data.Result;
                  //         } else {
                  //             modalDialog.busyIndicator(false);
                  //             modalDialog.showBaseWnd({
                  //                 title: 'Ошибка',
                  //                 buttons: [{
                  //                     title: 'Хорошо',
                  //                     big: true,
                  //                     primary: true,
                  //                 }],
                  //                 onDrawContent: () => data.Result,
                  //             });
                  //         }
                  //     },
                  // });
                }

                return isValid;
              }
            }, {
              title: 'Отмена',
              big: true
            }],
            afterOpen: function afterOpen() {
              initMask();
            }
          });
        }
      });
    }); //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

    var modalCodeCountdown = {
      timerOn: true,
      timer: function timer(remaining) {
        // $('#check-validate-error').text('');
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        $('#check-time').html("\u041A\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0435\u0449\u0435: ".concat(m, ":").concat(s, " \u0441\u0435\u043A."));
        remaining -= 1;

        if (remaining >= 0 && modalCodeCountdown.timerOn) {
          setTimeout(function () {
            modalCodeCountdown.timer(remaining);
          }, 1000);
          return;
        } else {
          $('#check-confirmation-code').hide();
          $('#resend-check-param').show();
          $('#check-validate-error').text('Код больше не действителен или введен не верно');
          $('#check-time').html('');
        }

        if (!modalCodeCountdown.timerOn) {
          return;
        } // Do timeout stuff here

      }
    };

    function chekConfirmationCode(code) {
      return new Promise(function (resolve, reject) {
        $.ajax({
          type: 'POST',
          url: userSettingsWidgetParams.url.checkCode,
          data: {
            code: code
          },
          success: function success(xhr) {
            if (xhr.Success) {
              resolve(true);
            } else {
              resolve(false);
            }
          }
        });
      });
    }

    function maskLoginForDisplay(login, type) {
      if (type === 'Phone') {
        var numberForDisplay = login.split('');
        var countNum = login.length;

        if (numberForDisplay[0] === '+') {
          numberForDisplay.shift();
        }

        numberForDisplay.splice(0, countNum - 5, '*'.repeat(countNum - 5));
        return "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u0434, \u0432\u044B\u0441\u043B\u0430\u043D\u043D\u044B\u0439 \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 <span class=\"bold\">".concat(numberForDisplay.join(''), "</span>.");
      } else {
        return "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u0434, \u0432\u044B\u0441\u043B\u0430\u043D\u043D\u044B\u0439 \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B <span class=\"bold\">".concat(login, "</span>.");
      }
    }

    function chekLogin(modalSelector, login, type) {
      modalCodeCountdown.timerOn = false;
      $('#check-confirmation-code').hide();
      $('#resend-check-param').show();
      return new Promise(function (resolve, reject) {
        $.ajax({
          type: 'POST',
          url: userSettingsWidgetParams.url.checkData,
          data: {
            data: login,
            type: type
          },
          success: function success(xhr) {
            if (xhr.Success) {
              $('#check-param').show();
              $('#resend-check-param').hide();

              if (modalSelector) {
                $(modalSelector).closest('.modal').modalDlgClose();
                $('#check-code-modal').showAsModal({
                  title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 ".concat(type === 'Phone' ? 'номера телефона' : 'электронной почты'),
                  isAutoClosing: false,
                  inputs: [{
                    id: 'check-confirmation-code',
                    placeholder: 'Полученный код'
                  }],
                  buttons: [{
                    title: 'Отправить повторно',
                    id: 'resend-check-param',
                    big: true,
                    primary: false,
                    onClick: function onClick() {
                      $.ajax({
                        type: 'POST',
                        url: userSettingsWidgetParams.url.checkData,
                        data: {
                          data: login,
                          type: type
                        },
                        success: function success(response) {
                          if (response.Success) {
                            $('#resend-check-param').hide();
                            $('#check-confirmation-code').show();
                            $('#check-confirmation-code').val('');
                            $('#check-validate-error').text('');
                            modalCodeCountdown.timerOn = true;
                            modalCodeCountdown.timer(xhr.Result.LiveTime * 60);
                          } else {
                            $('#check-validate-error').text('Ошибка при запросе кода подтверждения');
                          }
                        }
                      });
                    }
                  }, {
                    title: 'Подтвердить',
                    big: true,
                    primary: true,
                    role: 'none',
                    onClick: function onClick() {
                      var confirmCode = $('#check-confirmation-code').val();

                      if (!confirmCode) {
                        $('#check-validate-error').text('Введите код подтверждения');
                      } else {
                        chekConfirmationCode(confirmCode).then(function (res) {
                          if (res) {
                            // Код подтвержден, переходим к регистрации
                            $('#check-code-modal').closest('.modal').forceModalDlgClose();
                            resolve(res);
                          } else {
                            // Тут повторная отправка кода подтверждения
                            modalCodeCountdown.timerOn = false;
                            $('#check-confirmation-code').hide();
                            $('#resend-check-param').show();
                          }
                        });
                      }
                    }
                  }],
                  afterOpen: function afterOpen() {
                    modalCodeCountdown.timerOn = true;
                    modalCodeCountdown.timer(xhr.Result.LiveTime * 60);
                    $('#check-validate-error').text('');
                    $('.modal-dialog').css('width', '450px'); // $('#resend-check-param').hide();

                    $('#checked-phone-number').html(maskLoginForDisplay(login, type));
                    $('[data-btnrole=close]').on('click', function () {
                      $('#check-code-modal').closest('.modal').forceModalDlgClose();
                      $('#check-validate-error').text('');
                      modalCodeCountdown.timerOn = false;
                    });
                  }
                });
              }
            } else {
              modalDialog.showBaseWnd({
                title: 'Ошибка',
                buttons: [{
                  title: 'Хорошо',
                  big: true,
                  primary: true
                }],
                onDrawContent: function onDrawContent() {
                  return xhr.Result;
                }
              });
            }

            $('#check-validate-error').text('');
          }
        });
      });
    } //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


    $(document).on('click', '.social-link-unbind', function () {
      var _this = this;

      var $credentailsModal = $('#personCredentialsModal');
      $credentailsModal.html(userSettingsWidgetParams.template.socialsTemplate);
      $credentailsModal.showAsModal({
        title: 'Внимание',
        buttons: [{
          title: 'Да',
          big: true,
          primary: true,
          onClick: function onClick() {
            var socialNetwork = $($(_this).siblings().first()).attr('data-social');
            delSnMapping(socialNetwork);
          }
        }, {
          title: 'Нет',
          big: true
        }]
      });
    });
    $(document).on('click', '.social-link-item', function () {
      var socialNetwork = $($(this).first()).attr('data-social');
      var url = userSettingsWidgetParams.url.snAuth + socialNetwork;
      window.location.href = url; // обновляем темплейт с социальными сетями

      getSnMapping();
    });
  }

  function setParams(profileParams) {
    userSettingsWidgetParams = $.extend(true, userSettingsWidgetParams, profileParams);
  }

  function init(profileParams) {
    unbindHandlers();
    setParams(profileParams);
    compileTemplate();
    bindHandlers();
  }

  return {
    init: init
  };
}();